module.exports = __webpack_public_path__ + "static/media/accepted.26929dfd.svg";